import React from 'react';
import {Row, Col, Collapse, DropdownButton, MenuItem} from 'react-bootstrap';
import commentAdmin from '../static/comment_admin.svg';
import Moment from 'react-moment';
import {Editor} from 'react-draft-wysiwyg';
import {Link} from 'react-router-dom';

export const Thread = ({handlers, state, userId}) =>{
  return(
    <Row className="thread-content">
      <Col xs={12} sm={10} smOffset={1}>
        <Row className="back-button">
          <Col xs={12}>
            <Link id="goBack" to="/forum">
              <span className="glyphicon glyphicon-arrow-left"> すべてのスレッド</span>
            </Link>
          </Col>
        </Row>
        <Row className="title-row">
          <Col xs={12}>
            <div className="row-1 thread">
              <span className="title">{state.thread.name}</span>
              {state.thread.author_id===userId?
                <DropdownButton title={<i className="glyphicon glyphicon-pencil" />}
                  noCaret id="comment_dropdown" className="shaped_dropdown">
                  <MenuItem eventKey="1"
                    onClick={handlers.onThreadEditClick}>
                    修正
                  </MenuItem>
                  <MenuItem eventKey="2" onClick={handlers.onThreadDelete}>
                    削除
                  </MenuItem>
                </DropdownButton>:null
              }
            </div>
            <div className="row-2">
              <span>{state.thread.author}</span>
            </div>
          </Col>
        </Row>
        <Row className="text-row">
          <Col xs={12}>
            <div dangerouslySetInnerHTML={{__html:state.thread.contents}}></div>
          </Col>
        </Row>
        <div className="thread-time">
          <Moment format="YYYY-MM-DD">
            {state.thread.date}
          </Moment>
        </div>
        <div>
          <button onClick={handlers.onReplyBtnClick}>回答</button>
        </div>
        <Collapse in={state.commentBox}>
          <div className="test">
            <span>コメント</span>
            <textarea type="textarea" rows={4}
              value={state.comment} onChange={handlers.handleChange}/>
            <div className="comment-btns">
              <button className="comment-submit"
                onClick={handlers.onReplySubmit}>登録</button>
              <button className="comment-cancel"
                onClick={handlers.onReplyCancelClick}>
                キャンセル
              </button>
            </div>
          </div>
        </Collapse>
      </Col>
    </Row>
  );
};

function partA(comment){
  let {author, date, is_admin} = comment;

  return(
    <Row className={(is_admin?"admin":null)+" reply-title"}>
      <Col xs={12}>
        {is_admin?
          <span className="author">
          <img src={commentAdmin} alt="comment-admin"/>
          Musio Support</span>:
          <span className="author">{author}</span>
        }
        <Moment format="YYYY-MM-DD">{date}</Moment>
      </Col>
    </Row>
  );
}

function partB(id, data){
  let {contents, handlers, editArray} = data;
  let {onCommentEditChange, onEditCancel, onEditClick,
    onCommentEditSubmit,onDeleteClick} = handlers;

  return(
    <Row className="reply-text comment-owner">
      <Col xs={12}>
        {editArray.status[id]?
          <div className="comment-content">
            <span>{contents}</span>
          </div>:
          <div className="comment-edit">
            <textarea type="textarea" rows={4} value={editArray.comment[id]}
              onChange={(event)=>onCommentEditChange(id, event)} />
            <div className="comment-btns">
              <button className="comment-submit"
                onClick={(event)=>onCommentEditSubmit(id,event)}>
                登録</button>
              <button className="comment-cancel"
                onClick={(event)=>onEditCancel(id, event)}>
                キャンセル
              </button>
            </div>
          </div>
        }
        <DropdownButton title={<i className="glyphicon glyphicon-pencil" />}
          noCaret id="comment_dropdown" className="shaped_dropdown">
          <MenuItem eventKey="1"
            onClick={(evt)=>onEditClick(id, contents, evt)}>
            修正
          </MenuItem>
          <MenuItem eventKey="2" onClick={()=>onDeleteClick(id)}>
            削除
          </MenuItem>
        </DropdownButton>
      </Col>
    </Row>
  );
}

function partC(contents){
  return(
    <Row className="reply-text">
      <Col xs={12}>
        <div className="comment-content">
          <span>{contents}</span>
        </div>
      </Col>
    </Row>
  );
}

export const CommentSection=({handlers, state, userId})=>{
  return(
    <Row className="reply">
      <Col xs={12} sm={10} smOffset={1}>
        <Row className="title-row">
          <Col xs={12}>
            <span>すべての回答</span>
          </Col>
        </Row>
        {state.threadComments.map((comment,i)=>
          <Row className="reply-content" key={"comment_"+i}>
            <Col xs={12}>
              {partA(comment)}
              {comment.author_id===userId?
                partB(comment.id,
                  {contents:comment.contents, editArray:state.editArray,handlers:handlers}):
                partC(comment.contents)
              }
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

//if width of the photo is larger than the width of texteditor, set width to 100%
//otherwise, set the width to auto. set height to auto always
const TextEditor = ({handlers, editorState})=>{
  return(
    <Editor
      wrapperClassName="wrapper-class"
      editorClassName="editor-class"
      toolbarClassName="toolbar-class"
      editorState={editorState}
      toolbar={{
        options: ['inline','blockType','fontSize', 'list', 'textAlign','link','emoji','image'],
        image:{
          urlEnabled: false,
          uploadEnabled: true,
          uploadCallback: handlers.imageHandler,
          inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
        }
      }}
      onEditorStateChange = {handlers.onEditorStateChange}
    />
  )
}

export const Description=()=>{
  return(
    <Row className="title">
      <Col xs={12} className="text-center">
        <span className="main">
          スレッドの編集
        </span>
      </Col>
    </Row>
  )
}

export const EditThread=({handlers, thread})=>{
  return(
    <div>
      <Row className="edit-thread">
        <Col xs={12} sm={10} smOffset={1}>
          <div className="thread-info">
            <input className="input_author" placeholder="名前(オプション)" name="author" value={thread.author}
              onChange={handlers.onThreadEditChange}/>
            <input className="input_title" placeholder="タイトル" name="name" value={thread.name}
              onChange={handlers.onThreadEditChange}/>
          </div>
          <TextEditor handlers={handlers} editorState={thread.contents} />
        </Col>
      </Row>
      <Row className="post-buttons">
        <Col xs={4} smOffset={1}>
          <button type="submit" id="post-btn" onClick={handlers.onThreadEditSubmit}>
            登録
          </button>
          <button type="btn" id="cancel-btn" onClick={handlers.onThreadEditCancel}>
            キャンセル
          </button>
        </Col>
      </Row>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Forum.Thread.Components.js